/* eslint-disable no-unused-vars */
import {
  ENDPOINT_ROOT,
  PAGE_KEY_PARAM,
  PARSE_INT_RADIX,
  SEARCH_TERM_KEY_PARAM,
  TERM_KEY_PARAM,
} from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const getProducts = ({ queryKey, pageParam }, params) => {
  const [apiEndpoint, apiParams] = queryKey;
  const queryParams = {
    ...apiParams,
    [SEARCH_TERM_KEY_PARAM]: apiParams[TERM_KEY_PARAM],
    [PAGE_KEY_PARAM]: pageParam
      ? parseInt(pageParam, PARSE_INT_RADIX)
      : params[PAGE_KEY_PARAM],
  };

  return axiosAuth
    .get(`${ENDPOINT_ROOT}/${apiEndpoint}`, { params: queryParams })
    .then((res) => res.data)
    .then((data) => ({
      ...data,
      params,
      lastPage: parseInt(queryParams.page, PARSE_INT_RADIX),
    }));
};

export default getProducts;
